import { Car } from '@/types/cars.types';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';



import type { CarSlicecarState } from '../../../../types/core.component-props.types';
const initialState: CarSlicecarState = {
    selectedCar: null,
};

const carSlice = createSlice({
    name: 'car',
    initialState,
    reducers: {
        selectCar: (state, action: PayloadAction<Car>) => {
            state.selectedCar = action.payload;
        },
        RemoveSelectedCar: (state) => {
            state.selectedCar = null;
        },
    },
});

export const { selectCar, RemoveSelectedCar } = carSlice.actions;
export default carSlice.reducer;
